import { createQuerySuggestionsPlugin } from "@algolia/autocomplete-plugin-query-suggestions";
import { useI18n } from "vue-i18n";
import { useLanguages } from "@/core/composables";
import { globals } from "@/core/globals";
import { prefixLocaleUrl } from "@/core/utilities";
import { ALGOLIA_INDEX_LANGUAGES } from "@/shared/thorlabs/search";
import { searchClient } from "./searchClient";

export function createQuerySuggestionsPluginInstance() {
  const { currentLocale, defaultLocale } = useLanguages();
  const safeLocale = (ALGOLIA_INDEX_LANGUAGES as readonly string[]).includes(currentLocale.value)
    ? currentLocale.value
    : "en";
  const productsIndexName = `${globals.algoliaConfig?.indexNamePrefix ?? ""}${safeLocale}_query_suggestions`;
  const { t } = useI18n();
  return createQuerySuggestionsPlugin({
    searchClient: searchClient.value,
    indexName: productsIndexName,
    getSearchParams() {
      return {
        hitsPerPage: 10,
      };
    },
    transformSource({ source }) {
      return {
        ...source,
        templates: {
          ...source.templates,
          item(params) {
            const { html, item, components } = params;
            return html`
              <div class="aa-Item" style="cursor: pointer;">
                <a
                  href="${prefixLocaleUrl(`/search?q=${item.objectID}`, currentLocale.value, defaultLocale.value)}"
                  onClick=${() => {
                    const event = new CustomEvent("closeSearchDropdown");
                    document.dispatchEvent(event);
                  }}
                >
                  <span class="aa-ItemContent"
                    ><span>${components.ReverseHighlight({ hit: item, attribute: "query" })}</span></span
                  >
                </a>
              </div>
            `;
          },
          noResults({ html }) {
            return html`${t("autocomplete.search.no_matches")}`;
          },
        },
      };
    },
  });
}
